import React from 'react';
import { StyledDateRangePicker } from './index.styled';
import { Moment } from 'moment';

type AppDateRangePickerProps = {
  onChangeValue?: (dates: [Moment | null, Moment | null] | null, dateStrings: [string, string]) => void;
  value?: [Moment | null, Moment | null] | null;
  [x: string]: any;
};

const AppDateRangePicker: React.FC<AppDateRangePickerProps> = ({
  onChangeValue,
  value,
  ...rest
}: AppDateRangePickerProps) => {
  const onChange = (dates: [Moment | null, Moment | null] | null, dateStrings: [string, string]) => {
    onChangeValue && onChangeValue(dates, dateStrings);
  };

  return (
    <StyledDateRangePicker
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
};

export default AppDateRangePicker;
